import React from 'react';
import './Rightbar.scss';
import { Suspense, lazy } from "react";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import ROS_Top_336_280 from '../../pages/ad-units/ros_top_300_250';
import ROS_Middle_336_280 from '../../pages/ad-units/ros_middle_300_250';
const MustRead = React.lazy(() => import("../../components/MustRead/Mustread"));
const CricketUpdate = React.lazy(() => import( '../../components/CricketUpdate/Cricketupdate'));
const PhotoGalleryList = React.lazy(() => import( '../../components/PhotoGalleryList/PhotoGalleryList'));
//import timelineimg1 from '../../assets/img/sport/';
const Horroscope = React.lazy(() =>
  import("../../components/horroscope/horroscope")
);
export default class Rightbar extends React.PureComponent {
    render() {
        const renderLoader = () => <div className="loading_screen"></div>;
        let Rightbar = this.props.Rightbar;
        const RightbarItems = Rightbar.map((item, i) => {
          if (item.Type == "PageList") {
            return (
              <Suspense fallback={renderLoader()}>
               <MustRead dataFromParent={[item]} />
               <br />
               </Suspense>
            );
          }
          if (item.Type == "Videos") {
            return (
              <Suspense fallback={renderLoader()}>
              {/* <iframe
                className="" style = {{width : "320px", height : "270px" ,padding : "5px"}}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                src={item.Items[0].EmbedUrl}
              ></iframe> */}
              <LiteYouTubeEmbed 
              style = {{width : "320px", height : "270px" ,padding : "5px"}}
              id={item.Items[0].EmbedUrl.split("/").pop()}
            title="youtube embed"
            poster="mqdefault"
            webp = {true}
    />
                <br />
            </Suspense>
            );
          }
          if (item.Type == "PhotoGallery") {
            return (
              <Suspense fallback={renderLoader()}>
             <PhotoGalleryList dataFromParent={[item]}/>
                <br />
            </Suspense>
            );
          }
          if (item.Type == "CricketTicker") {
            return (
              <Suspense fallback={renderLoader()}>
              <CricketUpdate CricketData = {this.props.CricketData}/>
              <br />
            </Suspense>
            );
          }
          if (item.Type == "Rashifal") {
            return (
              <Suspense fallback={renderLoader()}>
              <Horroscope Horoscope={[item]} />
              <br />
            </Suspense>
            );
          }

        })
        return (
            <>
              

              <div className="ads_block m-b-15">
            <Suspense fallback={renderLoader()}>
               <ROS_Top_336_280 AdData = {this.props.googleAds}/>
               </Suspense>
              </div>
              {  RightbarItems }
              <div className="ads_block m-b-15 m-t-15">
              <Suspense fallback={renderLoader()}>
              <ROS_Middle_336_280 AdData = {this.props.googleAds}/>
               </Suspense>
              </div>
           
            </>
        )
    }
}